<template lang="html">
  <section>
    <div class="tag-submit grupo-exportar">
      <!-- <a class=" btn btn-historico btn-default" data-toggle="modal" data-target="#modalHistoricoSla">Histórico</a> -->
      <button type="button" class="btn btn-primary btn-exportar" v-on:click="exportarSla()" v-if="controlerBtnSubmit"> Imprimir </button>
      <button type="button" class="btn btn-primary btn-exportar" disabled v-else><i class='fa fa-refresh fa-spin'></i> aguarde...</button>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      controlerBtnSubmit: true,
      env: process.env
    }
  },
  methods: {
    exportarSla: function () {
      // let vm = this
      this.controlerBtnSubmit = false
      this.$store.commit('setControleExibicaoImpressao', !this.$store.state.itensSla.controleExibicaoImpressao)
      setTimeout(() => {
        let conteudo = document.getElementsByClassName('container-visualizacao-sla')[0].innerHTML
        let printWin = window.open()
        printWin.document.write(`${conteudo}`)
        printWin.document.write(`
          <style>
            table {
              font-size:10px;
              border: 1px solid #ddd !important;
              width: 100%;
              }
            table td {
              border: 1px solid #ddd !important;
            }
            .desabilitar-impressao {display: none;}
            .ajusta-cabecalho-impressao {
              width: initial !important;
              min-width: initial !important;
              height: initial !important;
              min-height: initial !important;
              display: flex;
              justify-content: center;
            }
            .ajusta-resultado-calculo-impressao {
              background: #dcdcdc78 !important;
            }
          </style>
        `)
        printWin.document.close()
        printWin.focus()
        printWin.print()
        printWin.close()
        this.$store.commit('setControleExibicaoImpressao', !this.$store.state.itensSla.controleExibicaoImpressao)
        this.controlerBtnSubmit = true
      }, 0)
      // let ufContratoSelecionado = this.$store.state.ufContratoSelecionado.ufContratoSelecionado
      // let data = {
      //   'uf_id': ufContratoSelecionado.ufSelecionada,
      //   'tipo_contrato_id': ufContratoSelecionado.contratoSelecionado.tipo_contrato_id,
      //   'tipo_imovel_contrato_id': ufContratoSelecionado.contratoSelecionado.tipo_imovel_contrato_id,
      //   'tipo_imovel_servico_id': ufContratoSelecionado.contratoSelecionado.id
      // }
      // console.log(data)
      // this.$axios.post(`${this.env.FINANCEIRO.SLA}/exportarSla`, data, {
      //   headers: {
      //     'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
      //     'Content-Type': 'application/json'
      //   }
      // }).then(response => {
      //   vm.controlerBtnSubmit = true
      //   console.log(response.data)
      // }).catch(e => {
      //   vm.controlerBtnSubmit = true
      //   console.log('Algo deu errado')
      // })
    }
  }
}
</script>

<style lang="css" scoped>
.grupo-exportar {

}
.btn-exportar {
  background-color: #f39c12;
  border: solid 1px #ccc;
}
</style>



// WEBPACK FOOTER //
// Index.vue?d3031082